import React from "react";
var __jsx = React.createElement;
import Accordion from './Accordion';
function AccordionAdapter(_ref) {
  var entry = _ref.entry;
  return __jsx(Accordion, {
    accordionData: entry
  });
}
export default AccordionAdapter;